import React from 'react'
import Tag from '../Tag'
import {TagIcon} from '../Icon'
import {TagsViewProps} from './types'
import {styled} from '../../stitches/config'
import {useTranslation} from 'react-i18next'

const StyledTags = styled('div', {padding: '$metadataPaddingVertical $metadataPaddingHorizontal'})

const StyledHeader = styled('div', {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
})

const StyledHeaderName = styled('div', {
    '& svg': {
        color: '$icon',
        height: '$metadataHeaderIcon',
        marginRight: '$metadataHeaderIconMargin',
    },
    'display': 'flex',
    'flexGrow': 1,
    'fontSize': '$metadataHeaderText',
    'fontWeight': '$metadataHeaderText',
})

const StyledTagContainer = styled('div', {
    display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '1rem',
})

const StyledTag = styled('div', {})

const TagsView = (props: TagsViewProps): React.ReactElement => {
    const {tags} = props

    const {t} = useTranslation()

    return (
        <StyledTags>
            <StyledHeader>
                <StyledHeaderName>
                    <TagIcon />
                    <span>{t('Tags')}</span>
                </StyledHeaderName>
            </StyledHeader>
            <StyledTagContainer>
                {Object.keys(tags).map((tag_id) => (
                    <StyledTag key={tag_id}>
                        <Tag showParent={true} showTheme={true} {...tags[tag_id]} />
                    </StyledTag>
                ))}
            </StyledTagContainer>
        </StyledTags>
    )
}

export default TagsView
